// extracted by mini-css-extract-plugin
export default {"warning":"_827F7","row-gap":"_24850","rowGap":"_24850"};